import { motion } from "framer-motion";

const QUOTES = [
  {
    text: "Veer handled everything for my Anand Karaj — from the sherwani to the saafa. Everything was finalised at home, and my family still can't stop looking at the photos.",
    name: "Harpreet S.",
    tag: "Groom · Ludhiana",
  },
  {
    text: "We live in the UK — the entire styling happened online. Swatches were couriered, fittings done over video calls, and on the wedding day the look was absolutely perfect.",
    name: "Simran & Jaskaran",
    tag: "Couple · London (Online)",
  },
  {
    text: "Coordinating outfits for the whole family felt impossible. Veer built one palette and the baraat looked like a single, beautiful story.",
    name: "The Gill Family",
    tag: "Family Styling · Amritsar",
  },
];

const EASE = [0.16, 1, 0.3, 1];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="bg-[#FDFBF7] py-24 text-[#141414] lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: EASE }}
          className="mb-16 text-xs font-semibold uppercase tracking-[0.35em] text-[#B38C43]"
        >
          What Our Grooms Say
        </motion.p>

        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-8">
          {QUOTES.map((q, i) => (
            <motion.figure
              key={q.name}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.15, ease: EASE }}
              data-testid={`testimonial-${i + 1}`}
              className="border-t-2 border-[#141414] pt-8"
            >
              <span className="font-serif text-6xl leading-none text-[#C5A059]">“</span>
              <blockquote className="mt-2 font-serif text-lg italic leading-relaxed sm:text-xl">
                {q.text}
              </blockquote>
              <figcaption className="mt-6">
                <p className="text-sm font-semibold">{q.name}</p>
                <p className="mt-1 text-[10px] uppercase tracking-[0.28em] text-[#686152]">
                  {q.tag}
                </p>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
